<ng-container *transloco="let t">
  <div class="flex h-[50vh] w-[40rem] flex-col">
    <div class="flex-1">
      <div class="form-group row">
        <label class="col-sm-2 mb-0 py-2">{{ t("strategy-group-move-product-modal.move_to") }}</label>
        <div class="col-sm-10">
          <ISelect
            [options]="productStrategies"
            [selectedValue]="productStrategy.value"
            (selectedOptionChange)="setProductStrategy($event)"
            searchable
          />
        </div>
      </div>
      @if (productStrategy.value === "NewProductStrategy") {
        <div>
          <IInput
            class="w-full"
            [label]="t('sp-strategy-creation.strategy_name')"
            [placeholder]="t('strategy-group-add-product-modal.please_enter_a_name_for_your_main_strategy')"
            (valueChange)="setProductStrategyName($event)"
            [maxLength]="80"
          />

          <algo-mode-selection (algoModeConfig)="setAlgoModeConfig($event)" class="w-full" />
        </div>
      }
      @if (productStrategy.value === "NewStrategy") {
        <div>
          <IInput
            [label]="t('sp-strategy-creation.strategy_name')"
            [placeholder]="t('sp-strategy-creation.please_enter_a_name_for_your_strategy')"
            (valueChange)="setProductStrategyName($event)"
            [maxLength]="80"
          />
          <algo-mode-selection (algoModeConfig)="setAlgoModeConfig($event)" class="w-full" />
        </div>
      }
    </div>
    <div class="flex justify-end gap-2">
      <IButton label="{{ t('common.cancel') }}" color="white" (onClick)="close()" />
      <IButton
        label="{{ t('common.save') }}"
        [disabled]="invalid()"
        [loading]="loading()"
        [tooltipValue]="invalidTooltip()"
        (onClick)="save()"
        type="submit"
      />
    </div>
  </div>
</ng-container>
